import { render, staticRenderFns } from "./TranslationContainer.vue?vue&type=template&id=63b6b29e&scoped=true"
import script from "./TranslationContainer.vue?vue&type=script&lang=js"
export * from "./TranslationContainer.vue?vue&type=script&lang=js"
import style0 from "./TranslationContainer.vue?vue&type=style&index=0&id=63b6b29e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6b29e",
  null
  
)

export default component.exports